<template>
  <MeasureListWidget list-config-key="measures"/>
</template>

  
<script>
// Snippets/Components
import MeasureListWidget from "@/components/widgets/MeasureListWidget";

export default {
  name: "Measures",
  components: { MeasureListWidget },
  data: () => ({})
};
</script>
